"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var calculateColumnPlacement = function calculateColumnPlacement(childIndex, columnsCount) {
  if (columnsCount === 1) {
    return 1;
  }

  if (childIndex % columnsCount) {
    return childIndex % columnsCount;
  }

  return columnsCount;
};

var _default = calculateColumnPlacement;
exports.default = _default;